import { useMemo } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { fontWeight, iconBtnType, IconButton, Text } from '../../../../../../packages';
import { Drawer, drawerType } from '../../../../../../packages/ui/organisms/drawer';
import { useSelector } from 'react-redux';
import { getProfile } from '../../../../../../redux/modules/profile/selectors';
import { getAuth } from '../../../../../../redux/modules/auth/selectors';
import { MedicationBottomCard } from '../medication-card/MedicationBottomCard';
import { useStyles } from './MedicationDetail.styles';
import { ProfileInfoRole } from '../../../../../../components/v2/ProfileInfo';

const MedicationDetail = ({ open, onClose, medication, isNoDrawer, onClickNewReport, priorityType }) => {
  const classes = useStyles();
  const { isAdmin } = useSelector(getAuth);
  const { profile, demographicDetails } = useSelector(getProfile);
  const fullHistory = useMemo(() => {
    if (medication) {
      const { history, priority, ...rest } = medication;
      const current = { ...rest, priority, importanceLevel: priority };
      return history ? [current, ...history] : [current];
    }
    return [];
  }, [medication]);

  const getMemberAddress = () => {
    let address = demographicDetails.address1 || '';
    if (demographicDetails.address2) {
      if (address.length > 0) {
        address += ', ';
      }
      address += demographicDetails.address2 || '';
    }
    if (demographicDetails.city) {
      if (address.length > 0) {
        address += ', ';
      }
      address += demographicDetails.city || '';
    }
    if (demographicDetails.state) {
      if (address.length > 0) {
        address += ', ';
      }
      address += demographicDetails.state || '';
    }
    if (demographicDetails.zip) {
      if (address.length > 0) {
        address += ', ';
      }
      address += demographicDetails.zip || '';
    }
    return address.length > 0 ? address : 'Missing';
  };

  const renderContent = () => (
    <Box className={classes.container}>
      <Box className={clsx(classes.header, { [classes.headerNoDrawer]: isNoDrawer })}>
        <Box>
          <Text weight={fontWeight.BOLD} className={classes.headTitle}>
            All Reports - {medication.name}
          </Text>
          <Text weight={fontWeight.BOLD} className={classes.headSubtitle}>
            Member's Address: {getMemberAddress()}
          </Text>
        </Box>
        <IconButton icon="close" className={classes.closeBtn} onClick={onClose} />
      </Box>
      <Box className={clsx(classes.content, { [classes.contentNoDrawer]: isNoDrawer })}>
        <Box>
          {fullHistory?.map((report, index) => (
            <Box key={index}>
              <MedicationBottomCard medication={report} showBadge detail />
            </Box>
          ))}
        </Box>
      </Box>
      {(profile?.designation === ProfileInfoRole.NURSE_PRACTITIONER ||
        profile?.designation === ProfileInfoRole.PHYSICIAN ||
        isAdmin) && (
        <Box className={classes.footer}>
          <IconButton variant={iconBtnType.TEXT} onClick={onClose}>
            Close
          </IconButton>
          <IconButton
            // icon="plus"
            onClick={onClickNewReport}
            className={classes.newReportBtn}
            variant={iconBtnType.PRIMARY}
          >
            Update report
          </IconButton>
        </Box>
      )}
    </Box>
  );

  if (isNoDrawer) {
    return renderContent();
  }

  return (
    <Drawer open={open} onClose={onClose} variant={drawerType.NORMAL} className={classes.drawer}>
      {medication && renderContent()}
    </Drawer>
  );
};

export { MedicationDetail };
